import { observable, makeObservable } from "mobx";
import ObSummaryStore from "../../ObSummary/ObSummaryStore";

export default class ObSurveilPatientStore extends ObSummaryStore {
  selectedPanel = "waveform";
  constructor(props) {
    super(props);

    makeObservable(this, {
      selectedPanel: observable,
    });

    Object.assign(this, props);
  }
}
